module.exports = __webpack_public_path__ + "img/logo-nao-con-lineas.05334fd3.svg";